var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48005 5.10144C8.60682 5.33654 8 6.12835 8 7.03267V7.69508C8 7.74724 8.00393 7.79828 8.01147 7.84796C8.00392 7.89751 8 7.94825 8 7.99991V14.8452C8 15.53 7.31519 16.0196 6.6306 16.0016C6.58726 16.0005 6.54373 15.9999 6.5 15.9999C4.567 15.9999 3 17.1192 3 18.4999C3 19.8806 4.567 20.9999 6.5 20.9999C8.433 20.9999 10 19.8806 10 18.4999C10 18.3319 10 18.167 10 17.9999V9.22783C10 8.77567 10.3034 8.37976 10.74 8.26221L17.74 6.3776C18.3754 6.20653 19 6.68519 19 7.34322V12.8452C19 13.53 18.3152 14.0196 17.6306 14.0016C17.5873 14.0005 17.5437 13.9999 17.5 13.9999C15.567 13.9999 14 15.1192 14 16.4999C14 17.8806 15.567 18.9999 17.5 18.9999C19.433 18.9999 21 17.8806 21 16.4999C21 16.3311 21 16.1678 21 15.9999C21 11.7682 21 7.53647 21 3.30475C21 2.64673 20.3754 2.16807 19.74 2.33914L9.48005 5.10144Z",
    fill: "#0864A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/Track.9a30405a2767a0f6aeb5f1385caa51a7.svg";
export { ForwardRef as ReactComponent };